export const stringToNumber = result => window.Number(result);